import type { EntryPointComponent } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { RouteResources } from '@atlassian/react-resource-router';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { horizontalNavJiraResource } from '@jira/navigation-apps__resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { LegacyEntryRoute } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { RootLifecycleEntryPointContainer } from '@jira/platform__spa/src/view/RootLifecycleEntryPointContainer.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';
import { legacyBoardRoute } from '@jira/router-routes__legacy-board-routes/src/legacyBoardRoute.tsx';

const legacyBoardMigrationEmptyProps = {};
const legacyBoardMigrationEntryPoint0 = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-legacyBoard-0" */ './LegacyBoardRoot.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => legacyBoardMigrationEmptyProps,
	},
});

export const legacyBoardRouteEntry: LegacyEntryRoute<RouteResources> = createLegacyEntry(
	legacyBoardRoute,
	() => ({
		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_boards_backlog') ? undefined : LegacyPage,

		resources: [
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			horizontalNavJiraResource,
			// end of resources expanded from getNavigationSidebarProjectResource
		],

		entryPoint: () =>
			fg('nike_entrypoint_migration_boards_backlog') ? legacyBoardMigrationEntryPoint0 : undefined,
		entryPointContainer: fg('nike_entrypoint_migration_boards_backlog')
			? RootLifecycleEntryPointContainer
			: undefined,
	}),
);
